// Import Redux
import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
// Import Main Reducer
import reducer from './reducers/index'



// Create Store
const store = createStore(
  reducer,
  compose( applyMiddleware(thunk),
    typeof window === 'object' && typeof (window as any).__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
      ? (window as any).__REDUX_DEVTOOLS_EXTENSION__()
      : (f:any) => f
  )
)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch



export default store
